// extracted by mini-css-extract-plugin
module.exports = {"App":"App_App__15LM-","App-container":"App_App-container__3USVE"};